import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { CoreRoute } from '@app/eidos/models/core-constant.model';
import { EidosApiService } from '@app/eidos/services/eidos-api.service';
import { EidosSecurityService } from '@app/eidos/services/eidos-security.service';
import { lastValueFrom, Observable, of } from 'rxjs';


export const tokenGuard:CanActivateFn = (route, state) => {
  const eidosSecurityService:EidosSecurityService = inject(EidosSecurityService);

  return new Promise<boolean | UrlTree>(resolve => {
    lastValueFrom(amIAuthenticated()).then(authenticated => {
      if (authenticated === true) {
        resolve(authenticated);
      } else {
        if (authenticated !== false) {
          console.log('EidosTokenGuard ERROR: ', authenticated);
        }

        eidosSecurityService.clearAuthentication();
        eidosSecurityService.setRequestedRoute(window.location.href.replace(window.location.origin, ''));
        window.location.href = '../' + CoreRoute.Login;
      }
    });
  });
};

function amIAuthenticated(): Observable<boolean | UrlTree> {
  const eidosSecurityService:EidosSecurityService = inject(EidosSecurityService);
  const eidosApiService:EidosApiService = inject(EidosApiService);
  const grantAccess = eidosSecurityService.amIAuthenticated();
  if (!grantAccess) {
    return eidosApiService.amIAuthenticated();
  } else {
    return of(true);
  }
}
